<template>
  <div class="activity-card__finished" :class="{ 'is-loading': isLoading }">
    <div class="icon-square-white">
      <b-spinner v-if="isLoading" small class="text-success" />
      <feather-icon v-else icon="CheckCircleIcon" size="30" class="text-success" />
    </div>
    <div class="labels">
      <div class="card-activity-title font-raleway font-weight-bold text-white">{{ title }}</div>
      <div v-if="datetime" class="card-activity-timestamp text-white-50">{{ datetime }}</div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
  name: "ActivityCardFinished",
  components: {
    BSpinner,
    FeatherIcon,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    datetime: {
      type: String,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.activity-card__finished {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #28c76f !important;
  border: 1px solid #20a359 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 14px 12px;
  box-sizing: border-box;
  color: #ffffff;
  box-shadow: none;

  &.is-loading {
    cursor: wait;
  }

  .icon-square-white {
    width: 52px;
    height: 52px;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    box-shadow: none;

    svg,
    .feather {
      width: 26px;
      height: 26px;
      stroke: #28c76f;
    }
  }

  .labels {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    text-align: center;

    .card-activity-title {
      font-size: 15px;
      line-height: 20px;
      color: #ffffff !important;
      font-family: "Raleway", sans-serif;
      font-weight: 700;
      margin: 0;
    }

    .card-activity-timestamp {
      font-size: 12px;
      line-height: 16px;
      color: rgba(255, 255, 255, 0.85);
      font-family: "Raleway", sans-serif;
      margin-top: 2px;
    }
  }
}

@media (max-width: 480px) {
  .activity-card__finished {
    padding: 16px 10px;

    .icon-square-white {
      width: 48px;
      height: 48px;
      margin-bottom: 8px;

      svg,
      .feather {
        width: 24px;
        height: 24px;
      }
    }

    .labels {
      .card-activity-title {
        font-size: 14px;
        line-height: 18px;
      }

      .card-activity-timestamp {
        font-size: 11px;
      }
    }
  }
}
</style>
